import { Table } from "antd";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { DoubleLeftOutlined, DoubleRightOutlined } from "@ant-design/icons";
import { v4 as uuidv4 } from "uuid";
import "./Table.css";


export const Tabla = ({ dataList, columns, expandable, selection, RowData, inmuebles, abogados, situaciones = [], pagination = true, setPage, setLimit, /* setVisibleRows, */ className  }) => {
  const location = useLocation();

  const [data, setData] = useState([]);
  const [expandedRow, setExpandedRow] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const hasSelected = selectedRowKeys.length > 0;

  useEffect(() => {
    if (dataList && dataList?.length) {
      const result = dataList.map((e) => {
        if (e.uuid) {
          return e;
        }
        else {
          return {
            uuid: uuidv4(),
            ...e,
          };
        }
      });

      setData(result);
    } else {
      setData([]);
    }

  }, [dataList]);


  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const showTotal = (total) => {
    return <span style={{ fontWeight: 600, color: "#17a2b8" }}>TOTAL: {total} resultados</span>;
  };

  const handleChange = (e) => {
    if (e.current !== currentPage) {
      setExpandedRow([]);
      setCurrentPage(e?.current);

      if(setPage){
        setPage(e?.current);
      }
      if(setLimit){
        setLimit(e?.pageSize);
      }      
    }
  };

  return (
    <div className={`table-container ${className}`}>
      {hasSelected ? (
        <span style={{ marginLeft: 8 }}>
          Selected ${selectedRowKeys.length} items
        </span>
      ) : null}
      <Table
        bordered
        columns={columns.filter(e => !e.hidden)}
        dataSource={data}
        rowSelection={selection && rowSelection}
        expandable={expandable ? {
          defaultExpandAllRows: false,
          expandedRowRender: function (record) {
            return (
              record ? <RowData record={record} pathname={location?.pathname} inmuebles={inmuebles} abogados={abogados} situaciones={situaciones} /> : ""
            );
          },
          onExpandedRowsChange: (rowsKey) => setExpandedRow(rowsKey),
          expandedRowKeys: expandedRow
        } : {}}
        onChange={handleChange}

        rowKey={(record) => record?.uuid}

        pagination={pagination && {
          position: ["none", "bottomRight"],
          showTotal,
          itemRender: (page, type, element) => {
            if (type === "prev") {
              return <DoubleLeftOutlined />;
            }
            else if (type === "next") {
              return <DoubleRightOutlined />;
            }
            return element;
          },
          // showQuickJumper: true,
        }}

      />
    </div>
  );
};


